import { useContext, useState } from "react";
import UiContext from "../../../../store/ui-context";
import useAPIRequest from "../../../../custom_hooks/simple/useAPIRequest";

const defaultTake = 10;

export const useAPIGetDashboardKabagTransport = () => {
  const uiContext = useContext(UiContext);
  const { requestGet, loading } = useAPIRequest();

  const [dataDashboard, setDataDashboard] = useState({
    data_mobil: {
      sedang_berjalan: 0,
      sudah_pulang: 0,
      belum_pulang: 0,
    },
    data_dutro: {
      sedang_berjalan: 0,
      sudah_pulang: 0,
      belum_pulang: 0,
    },
    data_trado: {
      sedang_berjalan: 0,
      sudah_pulang: 0,
      belum_pulang: 0,
    },
    data_problems: [],
    data_status_kendaraans: [],
    data_warning_services: [],
  });

  // ========== API CALL ==========
  const fetchData = async () => {
    return requestGet({
      fullUrl: `/api/dashboard/index`,
      params: {
        take: defaultTake,
        with_warning_services: 1,
      },
      onSuccess: ({ data }) => {
        const warnings = data?.data_warning_services || [];

        // --- Sort by (next - speedo_akhir) ascending ---
        const sortedWarnings = [...warnings].sort((a, b) => {
          const aKm = a?.data_kendaraan?.speedo_akhir ?? 0;
          const bKm = b?.data_kendaraan?.speedo_akhir ?? 0;
          const aDiff = (a?.next ?? 0) - aKm;
          const bDiff = (b?.next ?? 0) - bKm;
          return aDiff - bDiff; // smallest first (closest to service)
        });

        // --- Update full dashboard data ---
        setDataDashboard(old => ({
          ...old,
          ...data,
          data_warning_services: sortedWarnings,
        }));
      },
      onError: ({ message }) => uiContext.showErrorMsg("Error", message),
    });
  };

  // ========== RETURN ==========
  return {
    loading,
    dataDashboard,
    fetchData,
  };
};
